import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

// Usar o mesmo domínio que a página está sendo servida (funciona em produção e preview)
const API = typeof window !== 'undefined' ? `${window.location.origin}/api` : '/api';

const GiftHistory = ({ creatorId, limit = 5 }) => {
  const [gifts, setGifts] = useState([]);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    fetchRecentGifts();
  }, [creatorId]);
  
  const fetchRecentGifts = async () => {
    try {
      const response = await axios.get(`${API}/gifts/recent/${creatorId}?limit=${limit}`);
      setGifts(response.data.gifts || []);
    } catch (error) {
      console.error('Erro ao carregar presentes:', error);
    } finally {
      setLoading(false);
    }
  };
  
  if (loading) {
    return (
      <div className="animate-pulse bg-[#1A1A1A] rounded-lg h-24"></div>
    );
  }
  
  if (gifts.length === 0) {
    return null;
  }
  
  return (
    <Card className="bg-[#1A1A1A] border-[#C79F5E]/20">
      <CardHeader className="pb-2">
        <CardTitle className="text-[#C79F5E] text-sm flex items-center gap-2">
          🎁 Presentes Recentes
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {gifts.map((gift, index) => (
          <div
            key={index}
            className="flex items-center gap-2 text-sm bg-[#0D0D0D]/50 rounded p-2"
          >
            <span className="text-xl">{gift.gift_icon}</span>
            <div className="flex-1 min-w-0">
              <p className="text-white truncate">
                <span className="text-[#C79F5E]">{gift.sender_name}</span>
                {' enviou '}
                {gift.quantity > 1 && <span>{gift.quantity}x </span>}
                {gift.gift_name}
              </p>
              {gift.message && (
                <p className="text-gray-500 text-xs truncate italic">"{gift.message}"</p>
              )}
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  );
};

export default GiftHistory;
